import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

export interface ForumFeedUntrustworthyUserFetchAction extends Action {
    readonly after: number; // Last item id
    readonly username: string;
}
export const FEED_UNTRUSTWORTHY_USER_FETCH_REQUEST = "FEED_UNTRUSTWORTHY_USER_FETCH_REQUEST";
export interface FeedUntrustworthyUserFetchRequestAction
    extends ForumFeedUntrustworthyUserFetchAction, APIRequestAction {
    readonly type: typeof FEED_UNTRUSTWORTHY_USER_FETCH_REQUEST;
}
export interface FeedUntrustworthyUserFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { comments: number[]; posts: number[]; user: number };
}
export const FEED_UNTRUSTWORTHY_USER_FETCH_SUCCESS = "FEED_UNTRUSTWORTHY_USER_FETCH_SUCCESS";
export interface FeedUntrustworthyUserFetchSuccessAction
    extends
        ForumFeedUntrustworthyUserFetchAction,
        APISuccessAction<FeedUntrustworthyUserFetchNormalizedResponse> {
    readonly type: typeof FEED_UNTRUSTWORTHY_USER_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
}

export const FEED_UNTRUSTWORTHY_USER_FETCH_FAILURE = "FEED_UNTRUSTWORTHY_USER_FETCH_FAILURE";
export interface FeedUntrustworthyUserFetchFailureAction
    extends ForumFeedUntrustworthyUserFetchAction, APIFailureAction {
    readonly type: typeof FEED_UNTRUSTWORTHY_USER_FETCH_FAILURE;
}

export const feedUntrustworthyUserFetch = {
    request: (username: string, after: number): FeedUntrustworthyUserFetchRequestAction => ({
        type: FEED_UNTRUSTWORTHY_USER_FETCH_REQUEST,
        username,
        after,
    }),
    success: (
        username: string,
        after: number,
        hasNext: number,
        hasPrevious: number,
        response: FeedUntrustworthyUserFetchNormalizedResponse,
    ): FeedUntrustworthyUserFetchSuccessAction => ({
        type: FEED_UNTRUSTWORTHY_USER_FETCH_SUCCESS,
        username,
        after,
        hasNext,
        hasPrevious,
        response,
    }),
    failure: (
        username: string,
        after: number,
        error: string,
    ): FeedUntrustworthyUserFetchFailureAction => ({
        type: FEED_UNTRUSTWORTHY_USER_FETCH_FAILURE,
        username,
        after,
        error,
    }),
};

// Feed UntrustworthyUser load
export const FEED_UNTRUSTWORTHY_USER_LOAD = "FEED_UNTRUSTWORTHY_USER_LOAD";
export interface FeedUntrustworthyUserLoadAction extends ForumFeedUntrustworthyUserFetchAction {
    readonly type: typeof FEED_UNTRUSTWORTHY_USER_LOAD;
}
export const feedUntrustworthyUserLoad = (
    username: string,
    after?: number,
): FeedUntrustworthyUserLoadAction => ({
    type: FEED_UNTRUSTWORTHY_USER_LOAD,
    username,
    after,
});
